<template>
    <div class="row" :id="tableId">
        <div class="col-12 main-data-table-container" style="overflow-x: auto; overflow-y: hidden;">
            <table class="table table-striped main-data-table">
                <thead class="main-thead">
                    <tr class="headers" style="text-align: center; cursor: pointer;">
                        <data-tables-header-column-component 
                            v-for="header in headers"
                            :key="header.key"
                            :colKey="header.key"
                            :class="header.headClasses"
                            :text="header.trans"
                            :sortingKey="sortingKey"
                            :isCheckbox="header.isCheckbox"
                            @checkbox-change="handleSelectAll"
                            :sortingDirection="sortingDirection"
                        />
                    </tr>
                    <tr v-if="filterHeader" class="filters">
                        <th v-for="header in headers" :key="header.key" :class="[header.headClasses]">
                            <input type="text" class="form-control filter-input-sm"
                                v-if="header.filterType == 'text'"
                                v-on:input="filterInput()"
                                v-model="filterValues[header.key]"                                
                                autocomplete="off"
                                value=""
                                v-bind:name="showName ? header.key : undefined"
                            >
                            <input type="text" style="border: #FFF;width:0px;" v-if="header.filterType == 'action'">
                            <input type="text" class="form-control filter-input-sm vue-datatables-daterange-filter"
                                v-if="header.filterType == 'date_range'"
                                :data-header-key="header.key"
                                v-model="filterValues[header.key]"                                
                                autocomplete="off"
                                value=""
                            >
                            <select class="form-control filter-input-sm"
                                v-if="header.filterType == 'simple_select'"
                                v-on:change="filterInput()"
                                v-model="filterValues[header.key]"                                
                            >
                                <option v-for="(option_value, option_index) in JSON.parse(Base64.decode(header.filterData)).options" 
                                    :key="option_index" 
                                    :value="option_index"
                                >
                                    {{ option_value }}
                                </option>
                            </select>
                            <select class="form-control filter-input-sm select2_tags"
                                v-if="header.filterType == 'search_select'"
                                v-model="filterValues[header.key]" 
                                :data-header-key="header.key"                            
                                ref="selectElement"  
                            >
                                <option v-for="(option_value, option_index) in JSON.parse(Base64.decode(header.filterData)).options" 
                                    :key="option_index" 
                                    :value="option_index"
                                >
                                    {{ option_value }}
                                </option>
                            </select>
                            <div v-if="header.key === 'selector_input'" class="d-flex justify-content-center">
                                <div class="custom-control custom-switch pl-5">
                                    <input type="checkbox" class="custom-control-input" :value="1" v-model="selectedAll" @change="selectAll()" :id="`${tableId}_filter_selector_input`">
                                    <label class="custom-control-label" :for="`${tableId}_filter_selector_input`"></label>
                                </div>
                            </div>
                        </th>
                    </tr>                 
                </thead>
                <tbody v-show="loading">
                    <tr>
                        <td :colspan="headers.length">
                            <div class="d-flex align-items-center justify-content-center" :style="{'min-height': `${loaderHeight}px`}">
                                <div>
                                    <i class="fa fa-cog fa-spin fa-4x"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody class="main-tbody" v-show="!loading">
                    <tr v-for="(row, rowIndex) in tableData[currentPage]" :key="rowIndex">
                        <template v-for="(header, headerIndex) in headers">
                            <data-tables-selector-component 
                                :key="headerIndex"
                                v-if="header.key === 'selector_input'"
                                :colKey="header.key"
                                :class="[header.cellClasses]"
                                :elementId="row.id || 0"
                                :tableId="tableId"
                            ></data-tables-selector-component>
                            <td v-else
                                :key="headerIndex"
                                :colKey="header.key"
                                :class="[header.cellClasses]"
                                v-html="row[header.key]">
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12" :id="`${tableId}_pagination`" v-if="pageCount > 1">
            <nav>
                <ul class="pagination justify-content-center">
                    <li v-if="currentPage == 1" class="page-item disabled" aria-disabled="true" aria-label="« First">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-backward backward-button"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(1)" type="button" class="page-link"  aria-label="« First">
                            <i class="fa fa-fast-backward backward-button backward-button"></i>
                        </button>
                    </li>

                    <li v-if="currentPage == 1" class="page-item disabled" aria-disabled="true" aria-label="« Previuos">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-backward backward-button"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(currentPage-1)" type="button" class="page-link"  rel="prev" aria-label="« Previuos">
                            <i class="fa fa-backward backward-button backward-button"></i>
                        </button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [4, 3, 2, 1]" :key="`${_}-before`" v-show="currentPage-i >= 1">
                        <button @click="changePage(currentPage-i)" type="button" class="page-link">{{ currentPage-i }}</button>
                    </li>

                    <li class="page-item active">
                        <button type="button" class="page-link">{{ currentPage }}</button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [1, 2, 3, 4]" :key="`${_}-after`" v-show="currentPage+i <= pageCount">
                        <button @click="changePage(currentPage+i)" type="button" class="page-link">{{ currentPage+i }}</button>
                    </li>

                    <li v-if="currentPage == pageCount" class="page-item disabled" aria-disabled="true" aria-label="Next »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(currentPage+1)" type="button" class="page-link" rel="next" aria-label="Next »">
                            <i class="fa fa-forward forward-button"></i>
                            </button>
                    </li>

                    <li v-if="currentPage == pageCount" class="page-item disabled" aria-disabled="true" aria-label="Last »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(pageCount)" type="button" class="page-link" aria-label="Last »">
                            <i class="fa fa-fast-forward forward-button"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            headers: [],
            filterValues: {},
            tableData: {},
            currentPage: 1,
            perPage: 20,
            requestNumber: 1,
            headerKeys: [],
            pageCount: 1,
            loadedPages: [],
            sortingKey: '',
            sortingDir: '',
            filterTimer: null,
            loading: true,
            loaderHeight: 100,
            selectedAll: 0,
        }
    },
    props: {
        tableId: {
            type: String,
            required: true,
        },
        sortKey: {
            type: String,
            required: false,
            default: 'id'
        },
        sortDir: {
            type: String,
            required: false,
            default: 'asc',
        },
        headersJson: {
            type: String,
            required: true,
        },
        filterHeader: {
            type: Boolean,
            required: false,
            default: false,
        },
        showName: {
            type: Boolean,
            required: false,
            default: false,
        },
        dataUrl: {
            type: String,
            required: true,
        },
        nonSorting: {
            type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        defaultFiltersJson:{
            type: String,
            required: false,
        }
    },
    created: function(){
        let vue = this;

        vue.headers = JSON.parse(Base64.decode(vue.headersJson));

        vue.sortingKey = vue.sortKey;
        vue.sortingDirection = vue.sortDir;

        $.each(vue.headers, function(index, element){
            vue.headerKeys.push(element['key']);
        });

        if(vue.defaultFiltersJson !== undefined){
            let filters = JSON.parse(Base64.decode(vue.defaultFiltersJson));
            $.each(filters, function(index, element){
                vue.filterValues[index] = element;
            });
        }

        vue.$nextTick(function () {
            let items = $(`#${vue.tableId}`).find('.vue-datatables-daterange-filter');

            let completeLocale = window.daterangepickerLocales[window.locale];
            completeLocale['format'] = 'YYYY-MM-DD';

            items.daterangepicker({
                'locale': completeLocale,
                'linkedCalendars': false,
            });

            items.on('apply.daterangepicker', function () {
                vue.filterValues[$(this).data('header-key')] = $(this).val();
                vue.filterInput();
            });

            items.on('cancel.daterangepicker', function () {
                vue.filterValues[$(this).data('header-key')] = null;
                vue.filterInput();
            });

            items.attr('autocomplete', 'off');
        
            items.each(function(index, element){
                if(vue.filterValues[$(element).data('header-key')] !== undefined){
                    let value = vue.filterValues[$(element).data('header-key')];
                    $(element).data('daterangepicker').setStartDate(value.split(' - ')[0]);
                    $(element).data('daterangepicker').setEndDate(value.split(' - ')[1]);
                }
            });
        });

        vue.completeDataRefresh();
    },
    mounted() {
        let vue = this;
        let selectItems = $(vue.$refs.selectElement);      
  
        selectItems.on('change', function () {
            let key = $(this).data('header-key');
            vue.filterValues[key] = $(this).val();
            vue.filterInput();
        });
    },
    methods: {
        handleSelectAll(isSelected) {
            this.allSelected = isSelected;
            $.each($('.main-tbody [type="checkbox"]'), function (index, item) { 
                if (isSelected) {
                    $(item).prop('checked', true);
                } else {
                    $(item).prop('checked', false);
                }
            });
        },
        sortCol(colKey){
            let vue = this;

            if(vue.nonSorting.includes(colKey)){
                return;
            }

            if(vue.sortingKey === colKey){
                vue.sortingDirection = (vue.sortingDirection === 'desc' ? 'asc' : 'desc');
            } else{
                vue.sortingDirection = 'asc'
            }

            vue.sortingKey = colKey;
            vue.completeDataRefresh();
        },
        filterInput(){
            let vue = this;

            if(vue.filterTimer){
                clearTimeout(vue.filterTimer);
                vue.filterTimer = null;
            }

            vue.filterTimer = setTimeout(function(){
                vue.completeDataRefresh();
            }, 250);
        },
        completeDataRefresh(){
            let vue = this;

            vue.loaderHeight = $(`#${vue.tableId}`).find('.main-tbody').outerHeight();
            vue.loading = true;
            vue.currentPage = 1;
            vue.tableData = {};
            vue.loadedPages = [];

            vue.loadCurrentPage();
        },
        loadCurrentPage(){
            let vue = this;

            if(vue.loadedPages.includes(vue.currentPage)){
                vue.loading = false;
                return;
            }

            vue.requestNumber++;

            let requestData = {
                requestNumber: vue.requestNumber,
                sortKey: vue.sortingKey,
                sortDir: vue.sortingDirection,
                page: vue.currentPage,
                perPage: vue.perPage,
                columns: vue.headerKeys,
                filters: vue.filterValues,
            };

            axios.post(vue.dataUrl, requestData)
            .then(function(response){
                if(response.data.requestNumber != vue.requestNumber){
                    return;
                }

                vue.currentPage = parseInt(response.data.page);
                vue.pageCount = parseInt(response.data.totalPages);

                if(response.data.tableData.length > 0){
                    vue.tableData[vue.currentPage] = response.data.tableData;
                    vue.loadedPages.push(response.data.page);
                }
         
                if (response.data.records_ids != undefined) {
                    $('#records_id').val(response.data.records_ids);
                }

                vue.loading = false;

                vue.$forceUpdate();
            })
            .catch(function(error){
                console.error(error);
            });

        },
        changePage(newPage){
            let vue = this;
            if(newPage < 0 || newPage > vue.totalPages || newPage == vue.currentPage){
                return;
            }

            vue.loaderHeight = $(`#${vue.tableId}`).find('.main-tbody').outerHeight();
            vue.loading = true;
            vue.currentPage = newPage;
            vue.loadCurrentPage();
        },
        selectAll: function(){
            $(`#${this.tableId}`).find('.table_selector_input').prop('checked', this.selectedAll);
        }
    },
}
</script>
